import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#invito", label: "Evento", testId: "nav-link-evento" },
  { href: "#museo", label: "Museo", testId: "nav-link-museo" },
  { href: "#programma", label: "Programma", testId: "nav-link-programma" },
  { href: "#location", label: "Location", testId: "nav-link-location" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[#ECECEA] bg-white/85 backdrop-blur-xl" data-testid="main-navbar">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-brand-logo">
          <img src="/logo-mark.png" alt="Logo 45 anni Tecnosystem" className="h-8 w-auto object-contain" />
          <span className="font-display text-base font-semibold uppercase tracking-[0.15em] text-[#232525]">
            Tecnosystem <span className="text-[#E30613]">45</span>
          </span>
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testId} className="text-sm font-bold uppercase tracking-[0.2em] text-[#5B5D5D] transition-colors duration-300 hover:text-[#E30613]">
              {l.label}
            </a>
          ))}
          <a href="#rsvp" data-testid="nav-cta-rsvp" className="rounded-full bg-[#E30613] px-5 py-2.5 text-xs font-bold uppercase tracking-[0.2em] text-white transition-all duration-300 hover:bg-[#B00410] hover:shadow-[0_8px_24px_rgba(227,6,19,0.35)]">
            Conferma Presenza
          </a>
        </nav>
        <button className="text-[#2B2D2D] md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="overflow-hidden border-t border-[#ECECEA] bg-white/95 md:hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col gap-4 px-6 py-6">
              {LINKS.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-sm font-bold uppercase tracking-[0.2em] text-[#5B5D5D]">
                  {l.label}
                </a>
              ))}
              <a href="#rsvp" onClick={() => setOpen(false)} className="text-sm font-bold uppercase tracking-[0.2em] text-[#E30613]">
                Conferma Presenza
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
